import className from "classnames";
import {
  GOVGR_PAGINATION,
  GOVGR_PAGINATION__ITEM,
  GOVGR_PAGINATION__ITEM__INACTIVE,
  GOVGR_PAGINATION__LIST,
} from "../../../../conf/styles/GovGrPagination";
import { useEffect, useState } from "react";
import GovGrPaginationNext from "./GovGrPaginationNext";
import GovGrPaginationPrevious from "./GovGrPaginationPrevious";
import GovGrPaginationLabel from "./GovGrPaginationLabel";
import GovGrPaginationItem from "./GovGrPaginationItem";
import { MAX_PAGINATION_ITEMS } from "./tablePaginationConstants";

const GovGrTablePagination = ({
  maxPaginationItems = MAX_PAGINATION_ITEMS,
  ...props
}) => {
  const { count, page, rowsPerPage, onPageChange } = props;
  const [currentPage, setCurrentpage] = useState(page + 1);
  const getTotalPages = (count, rowsPerPage) => {
    if (count / rowsPerPage > Math.floor(count / rowsPerPage)) {
      return Math.floor(count / rowsPerPage) + 1;
    }
    return Math.floor(count / rowsPerPage);
  };
  let ContainerWrapperClass = className(GOVGR_PAGINATION);
  const PaginationItemWrapperClass = className(GOVGR_PAGINATION__ITEM, {
    [GOVGR_PAGINATION__ITEM__INACTIVE]:
      getTotalPages(count, rowsPerPage) === currentPage + 1,
  });

  useEffect(() => {
    setCurrentpage(page + 1);
  }, [page]);

  const rebuildPagination = (currentPage, totalPages) => {
    const paginationItemList = [];
    if (totalPages <= maxPaginationItems) {
      for (let index = 0; index < totalPages; index++) {
        paginationItemList.push(
          <GovGrPaginationItem
            currentPage={currentPage}
            index={index + 1}
            onPageChange={onPageChange}
            key={index}
          />
        );
      }
    } else {
      paginationItemList.push(
        <GovGrPaginationItem
          currentPage={currentPage}
          index={1}
          onPageChange={onPageChange}
        />
      );
      if (currentPage > maxPaginationItems) {
        paginationItemList.push(
          <li className={PaginationItemWrapperClass}>
            <span>...</span>
          </li>
        );
      }
      // special case where last page is selected...
      // Without this special case, only 2 buttons would be shown after ... if you were on last page
      if (currentPage === totalPages) {
        paginationItemList.push(
          <GovGrPaginationItem
            currentPage={1}
            index={currentPage - 2}
            onPageChange={onPageChange}
          />
        );
      }
      // Print previous number button if currentPage > 2
      if (currentPage > 2) {
        paginationItemList.push(
          <GovGrPaginationItem
            currentPage={currentPage}
            index={currentPage - 1}
            onPageChange={onPageChange}
          />
        );
      }
      //Print current page number button as long as it not the first or last page
      if (currentPage !== 1 && currentPage !== totalPages) {
        paginationItemList.push(
          <GovGrPaginationItem
            currentPage={currentPage}
            index={currentPage}
            onPageChange={onPageChange}
          />
        );
      }
      if (currentPage < totalPages - 1) {
        paginationItemList.push(
          <GovGrPaginationItem
            currentPage={currentPage}
            index={currentPage + 1}
            onPageChange={onPageChange}
          />
        );
      }
      if (currentPage === 1) {
        paginationItemList.push(
          <GovGrPaginationItem
            currentPage={currentPage}
            index={currentPage + 2}
            onPageChange={onPageChange}
          />
        );
      }
      if (currentPage < totalPages - 2) {
        paginationItemList.push(
          <li className={PaginationItemWrapperClass}>
            <span>...</span>
          </li>
        );
      }
      if (totalPages > 1) {
        paginationItemList.push(
          <GovGrPaginationItem
            currentPage={currentPage}
            index={totalPages}
            onPageChange={onPageChange}
          />
        );
      }
    }
    return paginationItemList;
  };

  return (
    <nav className={ContainerWrapperClass}>
      <GovGrPaginationLabel
        count={count}
        rowsPerPage={rowsPerPage}
        currentPage={currentPage}
      />
      <ul className={GOVGR_PAGINATION__LIST}>
        <GovGrPaginationPrevious
          totalPages={getTotalPages(count, rowsPerPage)}
          currentPage={page}
          onPageChange={onPageChange}
        />
        {rebuildPagination(currentPage, getTotalPages(count, rowsPerPage)).map(
          (item, index) => item
        )}
        <GovGrPaginationNext
          totalPages={getTotalPages(count, rowsPerPage)}
          currentPage={page}
          onPageChange={onPageChange}
        />
      </ul>
    </nav>
  );
};

export default GovGrTablePagination;
